<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden" id="email-app">

    <vs-sidebar :click-not-close="clickNotClose" :hidden-background="clickNotClose" class="items-no-padding" parent="#email-app" v-model="isEmailSidebarActive">
      <email-sidebar :emailTags="emailTags" :mailFilter="mailFilter" @closeSidebar="toggleEmailSidebar"/>
    </vs-sidebar>

    <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

      <!-- SEARCH BAR -->
      <div class="flex border d-theme-dark-bg items-center">
        <feather-icon @click.stop="toggleEmailSidebar(true)" class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon"/>
        <vs-input class="vs-input-no-border vs-input-no-shdow-focus w-full" icon="icon-search" icon-no-border icon-pack="feather" placeholder="Search Mail" size="large" v-model="searchQuery"/>
      </div>

      <!-- EMAIL ACTION BAR -->
      <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
        <div class="flex items-center">
          <vs-checkbox :icon="selectAllIcon" class="select-all-chexkbox ml-0" icon-pack="feather" v-model="selectAllCheckBox">Select All</vs-checkbox>
        </div>
        <div class="flex">

          <vs-dropdown class="cursor-pointer" v-if="mailFilter != 'sent'" vs-custom-content vs-trigger-click>

            <feather-icon class="cursor-pointer" icon="FolderIcon" svg-classes="h-6 w-6"></feather-icon>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="moveTo('inbox')" v-if="mailFilter != 'inbox'">
                              <span class="flex items-center">
                                <feather-icon class="mr-2" icon="MailIcon" svgClasses="h-4 w-4"/>
                                <span>Inbox</span>
                              </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="moveTo('draft')" v-if="mailFilter != 'draft'">
                              <span class="flex items-center">
                                <feather-icon class="mr-2" icon="Edit2Icon" svgClasses="h-4 w-4"/>
                                <span>Draft</span>
                              </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="moveTo('spam')" v-if="mailFilter != 'spam'">
                              <span class="flex items-center">
                                <feather-icon class="mr-2" icon="InfoIcon" svgClasses="h-4 w-4"/>
                                <span>Spam</span>
                              </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="moveTo('trash')" v-if="mailFilter != 'trash'">
                              <span class="flex items-center">
                                <feather-icon class="mr-2" icon="TrashIcon" svgClasses="h-4 w-4"/>
                                <span>Trash</span>
                              </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click>

            <feather-icon class="cursor-pointer ml-5" icon="TagIcon" svg-classes="h-6 w-6"></feather-icon>

            <vs-dropdown-menu>
              <vs-dropdown-item :key="index" @click="updateLabels(label.value)" class="whitespace-no-wrap" v-for="(label, index) in emailTags">
                <div :class="'bg-' + label.color" class="h-3 w-3 inline-block rounded-full mr-3"></div>
                <span>{{ label.text }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <feather-icon @click="updateMarkUnread" class="ml-5 cursor-pointer" icon="MailIcon" svg-classes="h-6 w-6"/>

          <feather-icon @click="moveTo('trash')" class="cursor-pointer ml-5" icon="TrashIcon" svg-classes="h-6 w-6" v-if="mailFilter != 'trash'"/>
        </div>
      </div>

      <!-- EMAILS LIST -->
      <component :is="scrollbarTag" :key="$vs.rtl" :settings="settings" class="email-content-scroll-area" ref="mailListPS">
        <transition-group appear class="email__mails" name="list-enter-up" tag="ul">
          <li :key="String(mailFilter) + String(mail.id)" :style="{transitionDelay: (index * 0.1) + 's'}" @click="updateOpenMail(mail.id)" class="cursor-pointer email__mail-item" v-for="(mail, index) in mails">
            <mail-item :isSelected="isMailSelected(mail.id)" :mail="mail" @addToSelected="addToSelectedMails" @removeSelected="removeSelectedMail"/>
          </li>
        </transition-group>
      </component>
    </div>

    <!-- EMAIL VIEW SIDEBAR -->
    <email-view
      :emailTags="emailTags"
      :isSidebarActive="isSidebarActive"
      :mailFilter="mailFilter"
      :openMailId="openMailId"
      @closeSidebar="closeMailViewSidebar"
      @markUnread="updateSingleMarkUnread"
      @moveTo="moveCurrentTo"
      @nextMail="nextMail"
      @previousMail="previousMail"
      @removeMail="removeOpenMail">
    </email-view>
  </div>
</template>

<script>
  import EmailSidebar from './EmailSidebar.vue'
  import MailItem from './MailItem.vue'
  import EmailView from './EmailView.vue'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import moduleEmail from '@/store/email/moduleEmail.js'

  export default {
    data ()
    {
      return {
        openMailId:           null,
        selectedMails:        [],
        isSidebarActive:      false,
        showThread:           false,
        clickNotClose:        true,
        isEmailSidebarActive: true,
        settings:             {
          maxScrollbarLength: 60,
          wheelSpeed:         0.30
        }
      }
    },
    watch:      {
      isSidebarActive (value)
      {
        if (!value) this.showThread = false
      },
      mailFilter ()
      {
        this.selectedMails = []

        const scroll_el     = this.$refs.mailListPS.$el || this.$refs.mailListPS
        scroll_el.scrollTop = 0

        this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter)
        this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter})
        this.toggleEmailSidebar()
      },
      windowWidth ()
      {
        this.setSidebarWidth()
      }
    },
    computed:   {
      mailFilter ()
      {
        return this.$route.params.filter
      },
      emailTags ()
      {
        return this.$store.state.email.mailTags
      },
      searchQuery:       {
        get ()
        {
          return this.$store.state.email.mailSearchQuery
        },
        set (val)
        {
          this.$store.dispatch('email/setEmailSearchQuery', val)
        }
      },
      selectAllCheckBox: {
        get ()
        {
          return this.selectedMails.length
        },
        set (value)
        {
          value ? this.selectedMails = this.mails.map(mail => mail.id) : this.selectedMails = []
        }
      },
      mails ()
      {
        return this.$store.getters['email/filteredMails']
      },
      selectAllIcon ()
      {
        return this.selectedMails.length === this.mails.length ? 'icon-check' : 'icon-minus'
      },
      scrollbarTag () { return this.$store.getters.scrollbarTag },
      isMailSelected ()
      {
        return (mailId) => this.selectedMails.indexOf(mailId) !== -1
      },
      windowWidth ()
      {
        return this.$store.state.windowWidth
      }
    },
    methods:    {
      updateOpenMail (mailId)
      {
        this.openMailId      = mailId
        this.isSidebarActive = true
      },
      addToSelectedMails (mailId)
      {
        if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId)
      },
      removeSelectedMail (mailId)
      {
        const mailIndex = this.selectedMails.indexOf(mailId)
        if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1)
      },
      moveTo (to)
      {
        const payload = {emailIds: this.selectedMails, to}
        this.$store.dispatch('email/moveMailsTo', payload)
          .catch((error) => { console.error(error) })
        this.selectedMails = []
      },
      moveCurrentTo (to)
      {
        this.selectedMails = [this.openMailId]
        this.moveTo(to)
      },
      updateMarkUnread ()
      {
        const payload = {emailIds: this.selectedMails, unreadFlag: true}
        this.$store.dispatch('email/setUnread', payload)
        this.selectedMails = []
      },
      removeOpenMail ()
      {
        this.selectedMails = [this.openMailId]
        this.moveTo('trashed')
        this.isSidebarActive = false
      },
      toggleIsStarred ()
      {
        const payload = {mailId: this.currentMail.id, value: !this.currentMail.isStarred}
        this.$store.dispatch('email/toggleIsMailStarred', payload)
      },
      nextMail ()
      {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex + 1]) this.openMailId = this.mails[currentMailIndex + 1].id
      },
      previousMail ()
      {
        const currentMailIndex = this.mails.findIndex((mail) => mail.id === this.openMailId)
        if (this.mails[currentMailIndex - 1]) this.openMailId = this.mails[currentMailIndex - 1].id
      },
      updateSingleMarkUnread ()
      {
        this.selectedMails = [this.openMailId]
        this.updateMarkUnread()
        this.isSidebarActive = false
      },
      updateLabels (label)
      {
        this.$store.dispatch('email/updateLabels', {mails: this.selectedMails, label})
        this.selectedMails = []
      },
      closeMailViewSidebar ()
      {
        this.isSidebarActive = false
      },
      setSidebarWidth ()
      {
        if (this.windowWidth < 992)
        {
          this.isEmailSidebarActive = this.clickNotClose = false
        } else
        {
          this.isEmailSidebarActive = this.clickNotClose = true
        }
      },
      toggleEmailSidebar (value = false)
      {
        if (!value)
        {
          this.closeMailViewSidebar()
          if (this.clickNotClose)
          {
            return
          }
        }
        this.isEmailSidebarActive = value
      }
    },
    components: {
      MailItem,
      EmailSidebar,
      EmailView,
      VuePerfectScrollbar
    },
    created ()
    {
      this.$store.registerModule('email', moduleEmail)
      this.setSidebarWidth()

      this.$store.commit('email/UPDATE_MAIL_FILTER', this.$route.params.filter)        // Update Mail Filter
      this.$store.dispatch('email/fetchEmails', {filter: this.$route.params.filter}) // Fetch Emails From API
      this.$store.dispatch('email/fetchMeta')                                          // Fetch Unread Mails
      this.$store.dispatch('email/fetchTags')                                          // Fetch Mail Tags
    },
    beforeDestroy ()
    {
      this.$store.unregisterModule('email')
    },
    mounted ()
    {
      this.$store.dispatch('email/setEmailSearchQuery', '')
    }
  }

</script>


<style lang="scss">
  @import "@/assets/scss/vuexy/apps/email.scss";
</style>
